// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if ({70447:1,79000:1,68329:1,91507:1,63081:1}[chunkId]) return "" + chunkId + ".js";
	// return url for filenames based on template
	return "chunks/" + chunkId + ".js";
};